import React, { useState, useEffect } from "react";
import { List, X } from "@phosphor-icons/react";

const LOGO_URL =
  "/external-assets/lvfcborh_inboost_logo_horizontal_trsp-13.png";

const links = [
  { href: "/#tech", label: "Технология" },
  { href: "/#cases", label: "Сценарии" },
  { href: "/#roi", label: "ROI" },
  { href: "/#team", label: "Команда" },
  { href: "/#contact", label: "Контакты" },
];

export const Nav = ({ onDemo }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className={`flex items-center justify-between px-4 sm:px-6 py-3 rounded-2xl transition-all duration-300 ${
            scrolled ? "glass-strong" : "glass"
          }`}
        >
          <a href="/" className="flex items-center gap-2.5" data-testid="nav-logo">
            <img
              src={LOGO_URL}
              alt="InBoost"
              className="h-7 sm:h-8 w-auto object-contain"
              loading="eager"
            />
            <div className="hidden sm:block h-5 w-px bg-ink-text/10" />
            <div className="hidden sm:block mono text-[9px] tracking-[0.22em] text-brand uppercase">
              AI Engine
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="text-sm text-muted hover:text-ink-text transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={onDemo}
              data-testid="nav-demo-btn"
              className="hidden sm:inline-flex btn-primary px-4 py-2 rounded-lg text-sm font-semibold"
            >
              Запросить демо
            </button>
            <button
              onClick={() => setOpen((v) => !v)}
              data-testid="nav-mobile-toggle"
              className="lg:hidden text-ink-text p-1.5"
              aria-label="toggle menu"
            >
              {open ? <X size={22} /> : <List size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div
            className="lg:hidden mt-2 glass-strong rounded-2xl p-4 flex flex-col gap-3"
            data-testid="nav-mobile-menu"
          >
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm text-muted hover:text-ink-text"
              >
                {l.label}
              </a>
            ))}
            <button onClick={onDemo} className="btn-primary px-4 py-2 rounded-lg text-sm font-semibold">
              Запросить демо
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Nav;
